module.exports = __webpack_public_path__ + "assets/img/zip.5b8a9ed0.svg";